
export default [
  {
    path: '/public/job/:appId/job/:jobId/deliverable-assets/:contentAppId/business/:businessAppId',
    name: 'PublicDeliverableAssets',
    component: () => import('../views/job/deliverable/PublicDeliverableAssets.vue'),
    meta: {
      public: true,
      publicScopedToken: true
    },
    props: true
  },
  {
    path: '/job/:appId',
    name: 'JobHome',
    component: () => import('../views/job/JobHome.vue'),
    meta: {
      public: false,
      onlyLoggedOut: false
    }
  },
  {
    path: '/job/:appId/home/:contentAppId/business/:businessAppId',
    name: 'JobHomeContent',
    component: () => import('../views/job/JobHome.vue'),
    meta: {
      public: false,
      onlyLoggedOut: false
    }
  },
  {
    path: '/job/:appId/settings',
    name: 'JobSettings',
    component: () => import('../views/job/JobSettings.vue'),
    meta: {
      public: false,
      onlyLoggedOut: false
    }
  },
  {
    path: '/job/:appId/pools',
    name: 'JobPools',
    component: () => import('../views/job/pool/Pool.vue'),
    meta: {
      public: false,
      onlyLoggedOut: false
    }
  },
  {
    path: '/job/:appId/pools/:poolId/acl',
    name: 'PoolACL',
    component: () => import('../views/job/poolacl/PoolACL.vue'),
    meta: {
      public: false,
      onlyLoggedOut: false
    },
    props: true
  },
  {
    path: '/job/:appId/pools/:poolId/lanes',
    name: 'PoolLanes',
    component: () => import('../views/job/lane/LaneList.vue'),
    meta: {
      public: false,
      onlyLoggedOut: false
    },
    props: true
  },
  {
    path: '/job/:appId/statuses',
    name: 'JobStatuses',
    component: () => import('../views/job/status/Status.vue'),
    meta: {
      public: false,
      onlyLoggedOut: false
    }
  },
  {
    path: '/job/:appId/user-acl',
    name: 'JobUserAclSettings',
    component: () => import('../views/job/useracl/UserAclSettings.vue'),
    meta: {
      public: false,
      onlyLoggedOut: false
    }
  },
  {
    path: '/job/:appId/job/:jobId/deliverables/:contentAppId/business/:businessAppId',
    name: 'JobDeliverableManagement',
    component: () => import('../views/job/deliverable/JobDeliverableManagement.vue'),
    meta: {
      public: false,
      onlyLoggedOut: false
    },
    props: true
  },
  {
    path: '/job/:appId/job/:jobId/deliverable-assets-list/:contentAppId/business/:businessAppId',
    name: 'JobDeliverableAssetsList',
    component: () => import('../views/job/deliverable/DeliverableAssetsList.vue'),
    meta: {
      public: false,
      onlyLoggedOut: false
    },
    props: true
  },
  {
    path: '/job/:appId/job/:jobId/deliverable-assets/:contentAppId/business/:businessAppId',
    name: 'JobDeliverableAssets',
    component: () => import('../views/job/deliverable/DeliverableAssets.vue'),
    meta: {
      public: false,
      onlyLoggedOut: false
    },
    props: true
  },
  {
    path: '/job/:appId/job/:jobId/deliverables/:contentAppId/business/:businessAppId/multi-file-upload',
    name: 'JobMultiFileUpload',
    component: () => import('../views/job/deliverable/JobMultiFileUpload.vue'),
    meta: {
      public: false,
      onlyLoggedOut: false
    },
    props: true
  },
  {
    path: '/job/:appId/campaigns',
    name: 'JobCampaigns',
    component: () => import('../views/job/campaign/Campaign.vue'),
    meta: {
      public: false,
      onlyLoggedOut: false
    }
  },
  {
    path: '/job/:appId/job-definitions/:contentAppId/business/:businessAppId',
    name: 'JobDefinitions',
    component: () => import('../views/job/job_definition/JobDefinition.vue'),
    meta: {
      public: false,
      onlyLoggedOut: false
    }
  },
  {
    path: '/job/:appId/job-definitions/:jobDefinitionId/jobpoolstatus',
    name: 'JobPoolStatus',
    component: () => import('../views/job/job_definition/JobPoolStatus.vue'),
    meta: {
      public: false,
      onlyLoggedOut: false
    },
    props: true
  },
  {
    path: '/job/:appId/configuration-map',
    name: 'JobConfigurationMap',
    component: () => import('../views/job/map/Map.vue'),
    meta: {
      public: false,
      onlyLoggedOut: false
    }
  },
]
